module.exports = __webpack_public_path__ + "static/promo-tb-a66ba0601b2b053974552610c6690fdb.png";